import { SortOption } from '../../types';

export type ViewType = 'main' | 'sidepanel' | 'fullscreen';
export type SortType = 'prompts' | 'folders';
export type SortVariant = 'default' | 'compact';

export interface SortMenuProps {
  view: ViewType;
  currentPromptSort: SortOption;
  currentFolderSort: SortOption;
  onSortChange: (type: SortType, option: SortOption) => void;
  variant?: SortVariant;
  className?: string;
}

export const SORT_OPTIONS = {
  prompts: [
    { value: 'alpha-asc', label: 'A to Z' },
    { value: 'alpha-desc', label: 'Z to A' },
    { value: 'date-newest', label: 'Newest First' },
    { value: 'date-oldest', label: 'Oldest First' },
  ],
  folders: [
    { value: 'alpha-asc', label: 'A to Z' },
    { value: 'alpha-desc', label: 'Z to A' },
  ],
} as const;
